/* Optional printed message only. No network, clipboard, storage, or cart mutations.
 * Existing Shopify product forms submit the same Printed gift message property. */
if (!customElements.get('eos-message-composer')) {
  customElements.define('eos-message-composer', class extends HTMLElement {
    connectedCallback() {
      if (this._messageEvents || this._messageObserver) return;
      const setup = () => {
        if (!this.isConnected) return false;
        const field = this.querySelector('[data-eos-printed-message]');
        const editor = this.querySelector('[data-message-editor]');
        const example = this.querySelector('[data-message-example]');
        const actions = this.querySelector('[data-message-actions]');
        const use = this.querySelector('[data-message-use]');
        const write = this.querySelector('[data-message-write]');
        const remove = this.querySelector('[data-message-remove]');
        const count = this.querySelector('[data-message-count]');
        const status = this.querySelector('[data-message-status]');
        if (!field || !editor || !example || !actions || !use || !write || !remove || !count || !status) return false;
        this._messageObserver?.disconnect(); this._messageObserver = null;
        this._messageEvents = new AbortController();
        const signal = this._messageEvents.signal;
        const ready = this.closest('[data-eos-gift-details]')?.querySelector('[data-eos-message-ready]');
        const update = () => {
          const hasText = field.value.trim().length > 0;
          count.textContent = field.value.length + ' / ' + field.maxLength + ' characters';
          if (ready) ready.hidden = !hasText;
          remove.hidden = !hasText;
          use.textContent = hasText && field.value !== example.textContent.trim() ? 'Replace with suggested words' : 'Use this message';
        };
        const edit = () => { editor.hidden = false; field.focus({preventScroll:true}); };
        actions.hidden = false;
        editor.hidden = !field.value;
        update();
        use.addEventListener('click', () => {
          const words = example.textContent.trim();
          if (words.length > field.maxLength) { status.textContent = 'Please shorten these words to fit the message box.'; edit(); return; }
          field.value = words;
          field.dispatchEvent(new Event('input', {bubbles:true}));
          edit(); update();
          status.textContent = 'Ready to edit. These words will go with this bracelet when you add it to cart.';
        }, {signal});
        write.addEventListener('click', () => {
          // Opening the editor never erases words already typed.
          status.textContent = ''; edit(); update();
        }, {signal});
        remove.addEventListener('click', () => {
          field.value = ''; field.dispatchEvent(new Event('input', {bubbles:true}));
          editor.hidden = true; update();
          status.textContent = 'Message removed. No printed message will be added.';
          write.focus({preventScroll:true});
        }, {signal});
        field.addEventListener('input', () => { status.textContent = ''; update(); }, {signal});
        const form = field.form;
        if (form) form.addEventListener('reset', () => {
          queueMicrotask(() => { if (this.isConnected) { update(); editor.hidden = !field.value; status.textContent = ''; } });
        }, {signal});
        return true;
      };
      // Also works when Shopify injects a quick-shop panel or re-renders a section.
      if (!setup()) {
        this._messageObserver = new MutationObserver(() => { setup(); });
        this._messageObserver.observe(this, {childList:true,subtree:true});
      }
    }
    disconnectedCallback() {
      this._messageEvents?.abort(); this._messageEvents = null;
      this._messageObserver?.disconnect(); this._messageObserver = null;
    }
  });
}
